import React, { useState } from 'react';
import farmacoSlides from '../../utils/slides.js';
import iconCerrar from '../../icons/cancelar.png';
import iconFlechaDer from '../../icons/Flecha deslizarderecha.png';
import iconFlechaIzq from '../../icons/Flecha deslizar izquierda.png';
import './FarmacoCarouselModal.css';

const FarmacoCarouselModal = ({ visible, onClose, onAbrirFarmacoModal }) => {
  const [activeSlide, setActiveSlide] = useState(0);
  const [boldTitle, setBoldTitle] = useState(false);

  if (!visible) return null;

  const handleNext = () => {
    setActiveSlide(prev => (prev + 1) % farmacoSlides.length);
    setBoldTitle(false);
  };

  const handlePrev = () => {
    setActiveSlide(
      prev => (prev - 1 + farmacoSlides.length) % farmacoSlides.length
    );
    setBoldTitle(false);
  };

  const handleTitleClick = () => {
    if (activeSlide === 1) {
      setBoldTitle(true);
    }
  };

  // ❌ Solo cerrar el carrusel (cuando se presiona la X)
  const handleCerrarCarrusel = () => {
    onClose();
  };

  // ✅ Cerrar carrusel y abrir formulario (cuando se presiona OMITIR)
  const handleCerrarYMostrarFormulario = () => {
    onClose();
    onAbrirFarmacoModal();
  };

  return (
    <div className="farmaco-modal-overlay-carrucel">
      <div
        className={`farmaco-carousel-modal
        ${activeSlide === 1 ? 'farmaco-carousel-slide2' : ''}
        ${activeSlide === 2 ? 'farmaco-carousel-slide3' : ''}
      `}
      >
        {/* ❌ icono cerrar solo cierra el modal */}
        <img
          src={iconCerrar}
          alt="Cerrar"
          loading="lazy"
          className="farmaco-close"
          onClick={handleCerrarCarrusel}
        />

        {/* Flechas */}
        {activeSlide === 0 && (
          <div
            onClick={handleNext}
            style={{
              cursor: 'pointer',
              position: 'absolute',
              right: '10px',
              top: '50%',
              transform: 'translateY(-50%)',
              zIndex: 10,
            }}
          >
            <img
              src={iconFlechaDer}
              alt="Siguiente"
              loading="lazy"
              className="farmaco-next"
            />
          </div>
        )}

        {activeSlide === farmacoSlides.length - 1 && (
          <div
            onClick={handlePrev}
            style={{
              cursor: 'pointer',
              position: 'absolute',
              left: '10px',
              top: '50%',
              transform: 'translateY(-50%)',
              zIndex: 10,
            }}
          >
            <img
              src={iconFlechaIzq}
              alt="Anterior"
              loading="lazy"
              className="farmaco-prev"
            />
          </div>
        )}

        {activeSlide > 0 && activeSlide < farmacoSlides.length - 1 && (
          <>
            <div
              onClick={handlePrev}
              style={{
                cursor: 'pointer',
                position: 'absolute',
                left: '10px',
                top: '50%',
                transform: 'translateY(-50%)',
                zIndex: 10,
              }}
            >
              <img
                src={iconFlechaIzq}
                alt="Anterior"
                loading="lazy"
                className="farmaco-prev"
              />
            </div>

            <div
              onClick={handleNext}
              style={{
                cursor: 'pointer',
                position: 'absolute',
                right: '10px',
                top: '50%',
                transform: 'translateY(-50%)',
                zIndex: 10,
              }}
            >
              <img
                src={iconFlechaDer}
                alt="Siguiente"
                loading="lazy"
                className="farmaco-next"
              />
            </div>
          </>
        )}

        {/* Imagen del slide */}
        <img
          src={farmacoSlides[activeSlide].image}
          alt={`Slide ${activeSlide}`}
          loading="lazy"
          className={`farmaco-slide-image ${
            activeSlide === 0
              ? 'farmaco-slide-image-left'
              : activeSlide === 1
                ? 'farmaco-slide-image-slide2'
                : activeSlide === 2
                  ? 'farmaco-slide-image-slide3'
                  : ''
          }`}
        />

        {/* Texto */}
        <div
          className={`farmaco-text
          ${activeSlide === 1 ? 'farmaco-text-slide2' : ''}
          ${activeSlide === 2 ? 'farmaco-text-slide3' : ''}
        `}
        >
          <h2
            onClick={handleTitleClick}
            className={`farmaco-title ${activeSlide === 1 && boldTitle ? 'bold-title' : ''}`}
            dangerouslySetInnerHTML={{
              __html: `${farmacoSlides[activeSlide].title}<strong>${farmacoSlides[activeSlide].bold || ''}</strong>`,
            }}
          />
          {farmacoSlides[activeSlide].description && (
            <p>{farmacoSlides[activeSlide].description}</p>
          )}
        </div>

        {/* Dots */}
        <div className="farmaco-dots">
          {farmacoSlides.map((_, i) => (
            <span key={i} className={i === activeSlide ? 'active' : ''}></span>
          ))}
        </div>

        {/* ✅ Botón OMITIR que cierra y abre el formulario */}
        <button
          className="farmaco-omit"
          onClick={handleCerrarYMostrarFormulario}
        >
          Omitir
        </button>
      </div>
    </div>
  );
};

export default FarmacoCarouselModal;
